import type { TranslationDict } from '../en';

const ru: TranslationDict = {
  'header.buy': 'Купить',
  'header.sell': 'Продать',
  'spend.label': 'Вы тратите',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Вы получаете',
  'payment.label': 'Способ оплаты',
  'payment.select': 'Выбрать',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Нет доступных способов оплаты для этой пары',
  'wallet.label': 'Адрес кошелька для получения',
  'wallet.placeholderBuy': 'Введите адрес для получения',
  'wallet.placeholderSell': 'Введите адрес для отправки',
  'wallet.validating': 'Проверка адреса...',
  'wallet.invalid': 'Введите действительный адрес кошелька',
  'wallet.invalidServer': 'Недействительный адрес кошелька',
  'cta.buy': 'Купить {crypto}',
  'cta.sell': 'Продать {crypto}',
  'cta.gettingPrice': 'Поиск лучшей цены...',
  'cta.processing': 'Обработка...',
  'footer.poweredBy': 'Работает на ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Детали курса',
  'rate.close': 'Закрыть',
  'rate.updatesIn': 'Курс обновится через 00:{seconds}',
  'rate.noQuote': 'Котировка недоступна',
  'rate.exchangeRate': 'Обменный курс',
  'rate.processingFee': 'Комиссия за обработку',
  'rate.networkFee': 'Сетевая комиссия',
  'rate.provider': 'Провайдер',
  'toast.orderCreated': 'Заказ создан',
  'toast.redirecting': 'Перенаправление на оплату...',
  'toast.orderFailed': 'Ошибка заказа',
  'toast.couldNotCreate': 'Не удалось создать заказ',
  'toast.quoteError': 'Ошибка котировки',
  'toast.noProviders': 'Нет провайдеров',
  'toast.somethingWrong': 'Что-то пошло не так',
  'error.amountZero': 'Сумма должна быть больше 0',
  'error.minAmountFiat': 'Минимальная сумма — {min} {currency}',
  'error.minAmountCrypto': 'Минимальная сумма — {min} {currency}',
  'error.noProviders': 'Нет доступных провайдеров для этой комбинации',
  'error.currencyUnavailableBuy': 'Эта валюта недоступна для покупки',
  'error.currencyUnavailableSell': 'Эта валюта недоступна для продажи',
  'parity.info': 'С вас будет списано за {receiveAmount} {crypto}, остаток до {spendAmount} {fiat} будет зачислен на ваш аккаунт {partner}',
  'redirect.secureBadge': 'Безопасный платёж',
  'redirect.title': 'Продолжить оплату',
  'redirect.description': 'Вы будете перенаправлены на {gateway} для завершения оплаты.',
  'redirect.countdown': 'Перенаправление через {seconds}...',
  'redirect.openTab': 'Открыть ACH в новой вкладке',
  'redirect.cancel': 'Отмена',
  'checkout.noOrder': 'Заказ не найден',
  'checkout.goBack': 'Назад',
  'checkout.expired': 'Сессия оплаты истекла',
  'checkout.expiredDesc': 'Сессия истекла. Попробуйте снова.',
  'checkout.startOver': 'Начать заново',
  'checkout.cancel': 'Отмена',
  'checkout.loading': 'Загрузка оплаты...',
  'checkout.iframeTitle': 'Оплата через провайдера',
  'checkout.widgetTitle': 'Оплата',
  'checkout.unknownMethod': 'Неизвестный способ оплаты',
  'processing.default': 'Обработка вашего заказа...',
  'processing.pending': 'Ожидание подтверждения оплаты...',
  'processing.active': 'Обработка вашей транзакции...',
  'processing.generic': 'Обработка...',
  'processing.checkingStatus': 'Проверка статуса...',
  'processing.orderId': 'Номер заказа',
  'processing.provider': 'Провайдер',
  'processing.amount': 'Сумма',
  'processing.receiving': 'Получение',
  'processing.network': 'Сеть',
  'processing.toAddress': 'Адрес назначения',
  'processing.usuallyMinutes': 'Обычно это занимает несколько минут.',
  'processing.safeToClose': 'Вы можете безопасно закрыть эту страницу — мы отправим вам письмо по завершении.',
  'complete.buyTitle': 'Покупка завершена!',
  'complete.sellTitle': 'Продажа завершена!',
  'complete.buyDesc': 'Ваши {crypto} отправлены на ваш кошелёк.',
  'complete.sellDesc': 'Ваша выплата в {fiat} обрабатывается.',
  'complete.amountBuy': 'Полученная сумма',
  'complete.amountSell': 'Проданная сумма',
  'complete.paidBuy': 'Оплаченная сумма',
  'complete.paidSell': 'Сумма выплаты',
  'complete.network': 'Сеть',
  'complete.wallet': 'Кошелёк',
  'complete.transaction': 'Транзакция',
  'complete.provider': 'Провайдер',
  'complete.orderId': 'Номер заказа',
  'complete.completed': 'Завершено',
  'complete.viewExplorer': 'Посмотреть в Explorer',
  'complete.done': 'Готово',
  'errorStep.failed': 'Ошибка оплаты',
  'errorStep.cancelled': 'Заказ отменён',
  'errorStep.expired': 'Заказ истёк',
  'errorStep.refunded': 'Заказ возвращён',
  'errorStep.unknown': 'Что-то пошло не так',
  'errorStep.failedBuy': 'Ваш платёж не может быть обработан. Попробуйте снова или используйте другой способ оплаты.',
  'errorStep.failedSell': 'Ваша продажа не может быть обработана. Попробуйте снова.',
  'errorStep.cancelledBuy': 'Ваш заказ был отменён. Оплата не была произведена.',
  'errorStep.cancelledSell': 'Ваша продажа была отменена. Криптовалюта не была переведена.',
  'errorStep.expiredBuy': 'Ваш заказ истёк. Начните новую покупку.',
  'errorStep.expiredSell': 'Ваш заказ истёк. Начните новую продажу.',
  'errorStep.refundedBuy': 'Ваш платёж был возвращён. Средства появятся на вашем счёте в течение 5-10 рабочих дней.',
  'errorStep.refundedSell': 'Ваша криптовалюта была возвращена. Средства появятся в вашем кошельке в ближайшее время.',
  'errorStep.genericDesc': 'Произошла непредвиденная ошибка. Попробуйте снова.',
  'errorStep.orderId': 'Номер заказа',
  'errorStep.tryAgain': 'Попробовать снова',
  'errorStep.startOver': 'Начать заново',
  'errorStep.return': 'Вернуться',
  'errorStep.needHelp': 'Нужна помощь? Свяжитесь с ',
  'errorStep.reference': 'Ссылка: {orderId}',
  'confirm.buyTitle': 'Подтвердить покупку',
  'confirm.sellTitle': 'Подтвердить продажу',
  'confirm.loading': 'Загрузка...',
  'confirm.provider': 'Провайдер',
  'confirm.youPay': 'Вы платите',
  'confirm.youSell': 'Вы продаёте',
  'confirm.youReceive': 'Вы получаете',
  'confirm.wallet': 'Кошелёк',
  'confirm.network': 'Сеть',
  'confirm.refundAddress': 'Адрес для возврата',
  'confirm.parityNote': 'Сумма, списанная провайдером, может отличаться. Остаток до {amount} {crypto} будет зачислен на ваш аккаунт {partner}.',
  'confirm.processing': 'Обработка...',
  'confirm.confirmPay': 'Подтвердить и оплатить',
  'confirm.confirmSell': 'Подтвердить и продать',
  'confirm.payout': 'Выплата в {currency}',
  'modal.selectFiat': 'Выберите фиатную валюту',
  'modal.selectCrypto': 'Выберите криптовалюту',
  'modal.choosePayment': 'Выберите способ оплаты',
  'modal.selectCountry': 'Выберите вашу страну',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Популярные',
  'modal.recommended': 'Рекомендуемые',
  'modal.noCurrencies': 'Валюты не найдены',
  'modal.noPaymentMethods': 'Способы оплаты не найдены',
  'modal.noCountries': 'Страны не найдены',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Местоположение',
  'settings.darkMode': 'Тёмная тема',
  'settings.privacy': 'Политика конфиденциальности',
  'settings.terms': 'Условия использования',
  'settings.language': 'Язык',
  // ─── Additional ───
  'modal.chooseRamp': 'Выбрать Ramp',
  'modal.bestPrice': 'Лучшая цена',
  'modal.noQuotes': 'Нет доступных котировок для этого запроса',
  'modal.noProvidersFound': 'Провайдеры не найдены',
  'payment.unavailableFor': 'Нет доступных способов оплаты для {currency}',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Не удалось создать заказ',
  'errorStep.returnToMerchant': 'Вернуться к продавцу',
  'confirm.cryptoOnNetwork': '{crypto} в сети {network}',
  'payment.name.card': 'Карта',
  'payment.name.bankTransfer': 'Банковский перевод',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ru;
